import React, { 
    useState, 
    useEffect,
    useCallback } from 'react';
import {
    Button,
    Form,
    Input,
    Checkbox ,
    DatePicker,
    notification,
    Result,
} from 'antd';
import MaskedInput from "antd-mask-input";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import axios from 'axios';
import {
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

const { TextArea } = Input;

function MovingForm() {
    const [firstNameValidSuffix, setFirstNameValidSuffix] = useState(<></>);
    const [firstNameValid, setFirstNameValid] = useState(false);
    const [firstName, setFirstName] = useState('');

    const [lastNameValidSuffix, setLastNameValidSuffix] = useState(<></>);
    const [LastNameValid, setLastNameValid] = useState(false);
    const [lastName, setLastName] = useState('');

    const [emailValidSuffix, setEmailValidSuffix] = useState(<></>);
    const [emailValid, setEmailValid] = useState(false);
    const [email, setEmail] = useState('');

    const [phoneNumberValidSuffix, setPhoneNumberValidSuffix] = useState(<></>);
    const [phoneNumberValid, setPhoneNumberValid] = useState(false);
    const [phone, setPhone] = useState('');

    const [addressSuggestionList, setAddressSuggestionList] = useState(<></>);
    const [serviceAddress, setServiceAddress] = useState( headerVars.serviceAddress );
    const [serviceAddressValid, setServiceAddressValid] = useState(false);
    const [serviceSelection, setServiceSelection] = useState( '' );

    const [serviceAddressUnit, setServiceAddressUnit] = useState( headerVars.serviceAddressUnit );
    const [serviceAddressUnitNameValidSuffix, setServiceAddressUnitNameValidSuffix] = useState( headerVars.serviceAddressUnit );
    
    const [newServiceAddressUnit, setNewServiceAddressUnit] = useState( headerVars.newServiceAddressUnit );
    const [newServiceAddressUnitNameValidSuffix, setNewServiceAddressUnitNameValidSuffix] = useState( headerVars.newServiceAddressUnit );

    const [newAddressSuggestionList, setNewAddressSuggestionList] = useState(<></>);
    const [newServiceAddress, setNewServiceAddress] = useState( headerVars.newServiceAddress );
    const [newServiceSelection, setNewServiceSelection] = useState( '' );

    const [formSubmitting, setFormSubmitting] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [submissionResult, setSubmissionResult] = useState(<></>);

    const [addressUnknownChecked, setAddressUnknownChecked] = useState(false);

    const [preferredInstallDate, setPreferredInstallDate] = useState("");
    const [preferredInstallDateValid, setPreferredInstallDateValid] = useState(false);

    const [secondaryInstallDate, setSecondaryInstallDate] = useState("");
    const [secondaryInstallDateValid, setSecondaryInstallDateValid] = useState(false);

    const [daysToContact, setDaysToContact] = useState([]);
    const [timesToContact, setTimesToContact] = useState([]);

    const [additionalInformation, setAdditionalInformation] = useState("");

    const { executeRecaptcha } = useGoogleReCaptcha();
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    const [api, contextHolder] = notification.useNotification();

    //console.log("headerVars: ", headerVars);

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const onCheckboxChange = ( e, checked ) => {
        let currentVal = e.target.checked;
        let inputID = e.target.id;
        //console.log('currentVal:: ', currentVal);
        //console.log('inputID:: ', inputID);

        switch( inputID ) {
            case "address-unknown-checkbox":
                setAddressUnknownChecked( currentVal );
            break;
        }
    }

    const onCheckboxContactDayGroupChange = checkedValues => {
        setDaysToContact( checkedValues );
    };

    const onCheckboxContactTimeGroupChange = checkedValues => {
        setTimesToContact( checkedValues );
    };

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
          console.log('Execute recaptcha not yet available');
          return;
        }

        setFormSubmitting( true );

        const token = await executeRecaptcha('success');
        //console.log("token: ", token);
        console.log("Service address:: ", serviceAddress + " Unit:" + serviceAddressUnit );
        console.log("New service address:: ", newServiceAddress + " Unit:" + newServiceAddressUnit);
        console.log("First name:: ", firstName);
        console.log("Last name:: ", lastName);
        console.log("Email:: ", email);
        console.log("Phone:: ", phone);
        console.log("Address unknown:: ", addressUnknownChecked);
        console.log("Preferred install date:: ", preferredInstallDate);
        console.log("Secondary install date:: ", secondaryInstallDate);
        console.log("Days to contact:: ", daysToContact.toString());
        console.log("Times to contact:: ", timesToContact.toString());
        console.log("Additional inforamtion:: ", additionalInformation);

        let form_data = new FormData;
        form_data.append('action', 'startca_handle_form_submissions');
        form_data.append('token', token);
        form_data.append('form', 'moving');
        form_data.append('first_name', firstName);
        form_data.append('last_name', lastName);
        form_data.append('email', email);
        form_data.append('phone', phone);
        form_data.append('current_service_address', serviceAddress + " Unit:" + serviceAddressUnit);
        form_data.append('new_service_address', newServiceAddress + " Unit:" + newServiceAddressUnit);
        form_data.append('address_known', addressUnknownChecked);
        form_data.append('preferred_install_date', preferredInstallDate);
        form_data.append('secondary_install_date', secondaryInstallDate);
        form_data.append('days_to_contact', daysToContact.toString());
        form_data.append('times_to_contact', timesToContact.toString());
        form_data.append('additional_information', additionalInformation);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log( 'response:: ', response.data );
            setFormSubmitting( false );

            switch( response.data ) {
                case 'sent-successfully':
                openNotification('topLeft', 'sales');
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        style={{ paddingRight: "0" }}
                        status="success"
                        title="Your message was received sucessfully!"
                        subTitle="A member of our Support team will be in touch with you shortly."
                        extra={[]}
                    />
                 );
                break;

                case 'failed-send':
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        style={{ paddingRight: "0" }}
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                 );
                break;

                default:
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        style={{ paddingRight: "0" }}
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                 );
                break;
            }

        })
        .catch(function (error) {
            console.log(error);
            setSubmissionResult( 
                <Result
                    style={{ paddingRight: "0" }}
                    status="error"
                    title="Submission failed!"
                    subTitle="There was a problem submitting your request. Please try again later."
                    extra={[]}
                />
             );
        })
        .finally(function () {
            // always executed 
        });

    }, [executeRecaptcha,
        firstName,
        lastName,
        serviceAddressUnit,
        email,
        phone,
        serviceAddress,
        serviceSelection,
        newServiceAddress,
        newServiceAddressUnit,
        addressUnknownChecked,
        preferredInstallDate,
        secondaryInstallDate,
        daysToContact,
        timesToContact,
        additionalInformation,
        setFormSubmitting
    ]);

    const openNotification = ( placement, formName ) => {
        switch( formName ) {
            case 'sales': 
            api.info({
                message: "Message Received!",
                description: "Thanks for reaching out A member of our support team will be in contact soon.",
                placement,
            });
            break;
        }
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'sales-form-first-name': 
                if( currentVal.length < 2 ){ 
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerName = isValid ? currentVal : '';

                setFirstNameValid( isValid );
                setFirstName( customerName );
                setFirstNameValidSuffix( validationSuffix );
                
                if( !isValid ) { }
            break;

            case 'sales-form-last-name': 
                if( currentVal.length < 2 ){
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerLastName = isValid ? currentVal : '';

                setLastName( customerLastName );
                setLastNameValidSuffix( validationSuffix );
                setLastNameValid( isValid );

                if( !isValid ) { }
            break;

            case 'sales-form-phone-number': 
                if( !currentVal.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerPhone = isValid ? currentVal : '';

                setPhone( currentVal );
                setPhoneNumberValidSuffix( validationSuffix );
                setPhoneNumberValid( isValid );

                if( !isValid ) { }
            break;

            case 'contact-info-email': 
                if( !currentVal.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerEmail = isValid ? currentVal : '';

                setEmail( customerEmail );
                setEmailValidSuffix( validationSuffix );
                setEmailValid( isValid );

                if( !isValid ) { }
            break;

            case 'service-address-unit-name': 
                if( currentVal.length < 1 ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let serviceAddressUnit = isValid ? currentVal : '';

                setServiceAddressUnit( serviceAddressUnit );

                if( !isValid ) { }
            break;

            case 'new-service-address-unit-name': 
                if( currentVal.length < 1 ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let newServiceAddressUnit = isValid ? currentVal : '';

                setNewServiceAddressUnit( newServiceAddressUnit );

                if( !isValid ) { }
            break;

            case 'additional-information':
                setAdditionalInformation( currentVal );
            break;
        }
    }

    const handleOnAddressInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let form_data = new FormData;
        form_data.append('headers', {"Authorization": "Bearer "+headerVars.startAPIKey});

        if( currentVal.length > 6 ) {
            axios
            .get(headerVars.startAPIAddress+"/address/validate_telus?fullAddress="+currentVal, {headers:{"Authorization": "Bearer "+headerVars.startAPIKey}})
            .then(function(response){
                let suggestions = response.data.body.suggestions;
                //console.log('suggestions: ', suggestions);

                if(suggestions.length){
                    listAddressSugestions( suggestions, inputID ); 
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed 
            }); 
        }
    }

    const listAddressSugestions = ( suggestions, lookupType ) => {
        let suggestionListItems = suggestions.map( suggestion => {
            let suggestionText = suggestion.text.replace(', CAN', '');
            return(
                <li id={suggestion.magicKey} className='address-suggestion-item' onClick={() => handleSuggestionClick( suggestionText, lookupType ) }>
                    { suggestionText + ". " }
                </li>
            );
        } );

        switch( lookupType ) {
            case "service-address-input":
                setAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
            break;
            case "new-service-address-input":
                setNewAddressSuggestionList( <ul>{ suggestionListItems }</ul> );
            break;
        }
    }

    const handleSuggestionClick = ( suggestionText, lookupType ) => {

        switch( lookupType ) {
            case "service-address-input":
                setServiceAddress( suggestionText );
                setServiceAddressValid( true );
                setAddressSuggestionList(<></>);
                form.setFieldsValue({ "service-address": suggestionText});
            break;
            case "new-service-address-input":
                setNewServiceAddress( suggestionText );
                setNewAddressSuggestionList(<></>);
                form.setFieldsValue({ "new-service-address": suggestionText});
            break;
        }
    }

    const handleChangeServiceSelection = ( value ) => {
        setServiceSelection( value );
    }

    const onDateChange = (date, dateString, id) => {        
        switch( id ) {
            case "preferred-install-date":
                setPreferredInstallDate( dateString );
                setPreferredInstallDateValid( true );
            break;
            case "secondary-install-date":
                setSecondaryInstallDate( dateString );
                setSecondaryInstallDateValid( true );
            break;
        }
    };

    return (
        <div className='moving-form-form'>
            <Form form={ form }  style={{ display:( showForm ) ? "block" : "none" }}> 
                <h2>Current address where Start.ca services are provided</h2>
                <div className=' form-container-background'>
                    <div className="form-column-row">
                        <Form.Item
                            label="Service address"
                            labelCol={{ span: 24 }}
                            name="service-address"
                            className="form-item form-item-left-column address-item service-address padd-right"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your current service address!',
                                },
                            ]}
                        >
                            <Input
                                autoFocus
                                id="service-address-input"
                                name="service-address-input"
                                onChange={handleOnAddressInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Unit"
                            labelCol={{ span: 24 }}
                            name="unitname"
                            className="form-item company-name-item service-address-unit"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your company name!',
                                },
                            ]}
                        >
                            <Input
                                id="service-address-unit-name"
                                onChange={handleOnInputChange}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ width:"100%" }} className="suggestion-list-container">
                        { addressSuggestionList }
                    </div>

                    <div className="form-column-row">
                        <Form.Item
                            label="First name"
                            className="form-item form-item-left-column padd-right"
                            labelCol={{ span: 24 }}
                            name="firstname"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your first name!',
                                },
                            ]}
                        >
                            <Input
                                id="sales-form-first-name"
                                suffix={ firstNameValidSuffix }
                                onChange={handleOnInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Last name"
                            labelCol={{ span: 24 }}
                            name="lastname"
                            className="form-item"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your last name!',
                                },
                            ]}
                        >
                            <Input
                                id="sales-form-last-name"
                                suffix={ lastNameValidSuffix }
                                onChange={handleOnInputChange}
                            />
                        </Form.Item>
                    </div>
                    <div className="form-column-row">
                        <Form.Item
                            label="Email address"
                            name="emailaddress"
                            className="form-item padd-right"
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                required: true,
                                message: 'Please input your email!', 
                                },
                            ]}
                        >
                            <Input 
                                id="contact-info-email"
                                suffix={ emailValidSuffix }
                                onChange={handleOnInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Phone number"
                            labelCol={{ span: 24 }}
                            name="phonenumber"
                            className="form-item form-item-left-column" 
                            rules={[
                                {
                                required: false,
                                message: 'Please input your phone number!',
                                },
                            ]}
                        >
                            <MaskedInput
                                id="sales-form-phone-number"
                                mask={'(000) 000-0000'}
                                suffix={ phoneNumberValidSuffix }
                                onChange={handleOnInputChange}
                            />
                        </Form.Item>
                        
                    </div>
                </div>

                <hr/>
                <h2>New Address</h2>

                <div className=' form-container-background'>
                    <div className="form-column-row">
                        <Form.Item
                            label="New service address"
                            labelCol={{ span: 24 }}
                            name="new-service-address"
                            className="form-item form-item-left-column address-item service-address padd-right"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your current service address!',
                                },
                            ]}
                        >
                            <Input
                                id="new-service-address-input"
                                name="new-service-address-input"
                                onChange={handleOnAddressInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Unit"
                            labelCol={{ span: 24 }}
                            name="newunitname"
                            className="form-item company-name-item service-address-unit"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your company name!',
                                },
                            ]}
                        >
                            <Input
                                id="new-service-address-unit-name"
                                onChange={handleOnInputChange}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ width:"100%" }} className="suggestion-list-container">
                        { newAddressSuggestionList }
                    </div>
                    <div className="form-column-row">
                        <Form.Item
                            label=""
                            labelCol={{ span: 24 }}
                            name="address-unknown "
                            className="form-item"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your company name!',
                                },
                            ]}
                        >
                            <Checkbox 
                                onChange={onCheckboxChange}
                                id="address-unknown-checkbox"
                            >
                                Address unknown
                            </Checkbox>
                        </Form.Item>
                    </div>
                </div>
                
                <hr/>
                <h2>Desired connection date</h2>

                <div className=' form-container-background'>
                    <div className="form-column-row">
                        <Form.Item
                            label="Preferred date"
                            labelCol={{ span: 24 }}
                            name="preferred-date"
                            className="form-item padd-right"
                            rules={[
                                {
                                required: false,
                                message: 'Please select your preferred install date!',
                                },
                            ]}
                        >
                            <DatePicker 
                                id="preferred-install-date"
                                onChange={ ( date, dateString ) => onDateChange( date, dateString, "preferred-install-date" ) }
                            />
                            
                        </Form.Item>

                        <Form.Item
                            label="Second desired date ( In case the first is not available)"
                            labelCol={{ span: 24 }}
                            name="secondary-date"
                            className="form-item"
                            rules={[
                                {
                                required: false,
                                message: 'Please select a backup install date!',
                                },
                            ]}
                        >
                            <DatePicker 
                                id="secondary-install-date"
                                onChange={ ( date, dateString ) => onDateChange( date, dateString, "secondary-install-date" ) }
                            />
                            
                        </Form.Item>
                    </div>
                    <div className="form-column-row">
                        <Form.Item
                            label="Which days can an agent contact you"
                            labelCol={{ span: 24 }}
                            name="days-to-contact"
                            className="form-item"
                            rules={[
                                {
                                required: false,
                                message: 'Please select a backup install date!',
                                },
                            ]}
                        >
                            <Checkbox.Group style={{ width: '100%' }} onChange={ onCheckboxContactDayGroupChange }>
                                <Checkbox value="Monday">Monday</Checkbox>
                                <Checkbox value="Tuesday">Tuesday</Checkbox>
                                <Checkbox value="Wednesday">Wednesday</Checkbox>
                                <Checkbox value="Thursday">Thursday</Checkbox>
                                <Checkbox value="Friday">Friday</Checkbox>
                            </Checkbox.Group>
                            
                        </Form.Item>

                        <Form.Item
                            label="Best time to contact you"
                            labelCol={{ span: 24 }}
                            name="time-to-contact"
                            //style={{width:'20%', marginBottom:'0'}}
                            className="form-item"
                            rules={[
                                {
                                required: false,
                                message: 'Please select a backup install date!',
                                },
                            ]}
                        >
                            <Checkbox.Group style={{ width: '100%' }} onChange={ onCheckboxContactTimeGroupChange }>
                                <Checkbox value="Morning">Morning (9:00 AM to 12:00 PM)</Checkbox>
                                <Checkbox value="Afternoon">Afternoon (12:00 PM to 5:00 PM)</Checkbox>
                                <Checkbox value="Evening">Evening (5:00 PM to 8:30 PM)</Checkbox>
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                    <div className="">
                        <Form.Item
                            label="Additionnal information "
                            labelCol={{ span: 24 }}
                            name="additional-information"
                            className="form-item"
                            rules={[
                                {
                                required: false,
                                message: 'Please select a backup install date!',
                                },
                            ]}
                        >
                            <TextArea 
                                id="additional-information"
                                onChange={ handleOnInputChange }
                                rows={4}
                            />
                        </Form.Item>
                    </div>
                </div>

                <Button 
                    className='g-recaptcha business-form-button'
                    onClick={ handleReCaptchaVerify }
                    loading={ formSubmitting }
                    type="primary"
                    disabled={ ( 
                        firstNameValid && 
                        LastNameValid && 
                        emailValid &&
                        showForm &&
                        //preferredInstallDateValid &&
                        //secondaryInstallDateValid &&
                        serviceAddressValid ) ? false : true }
                >Submit request</Button>
                <p style={{ fontSize:"0.9rem" }}>Your personal information will be used in accordance with our <a style={{ fontSize:"0.9rem", fontWeight:"600" }} href="/privacy" target="_blank">Privacy Policy</a>.</p>
            </Form>
            { submissionResult }
            { contextHolder }
        </div>
    )
}

export default MovingForm
